/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attributes_Status_Sync_In_ProgressInputs */

const en_attributes_status_sync_in_progress = /** @type {(inputs: Attributes_Status_Sync_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending`)
};

/**
* | output |
* | --- |
* | "Sending" |
*
* @param {Attributes_Status_Sync_In_ProgressInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attributes_status_sync_in_progress = /** @type {((inputs?: Attributes_Status_Sync_In_ProgressInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attributes_Status_Sync_In_ProgressInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attributes_status_sync_in_progress(inputs)
});